import { useCallback, useContext, useRef } from 'react';

import { ExperienceTrackerContext } from '@confluence/experience-tracker/entry-points/component';
import { getLivePageEditExperienceName } from '@confluence/experience-tracker/entry-points/livePageExperiences';
import { useIsCurrentPageLive } from '@confluence/live-pages-utils/entry-points/useIsCurrentPageLive';
import { useIsLivePagesFeatureEnabled } from '@confluence/live-pages-utils/entry-points/useIsLivePagesFeatureEnabled';

export const useLivePageEditExperience = ({ contentId }: { contentId: string }) => {
	const wasStartedRef = useRef<boolean>(false);
	const experienceTracker = useContext(ExperienceTrackerContext);
	const isLivePage = useIsCurrentPageLive();
	const { livePageReleasePhase } = useIsLivePagesFeatureEnabled();

	return useCallback(() => {
		if (!wasStartedRef.current && isLivePage) {
			experienceTracker.start({
				name: getLivePageEditExperienceName(),
				attributes: {
					contentId,
					isLivePage,
					livePageReleasePhase,
				},
			});
			wasStartedRef.current = true;
		}
	}, [wasStartedRef, experienceTracker, isLivePage, contentId, livePageReleasePhase]);
};
